import { useState, useEffect } from "react";
import { useAbortedEffect, useHookForm } from "../../../../components/hooks";
import { useDispatch } from "react-redux";
import { setProgress, setToast } from "../../../../redux/slice/system";
import { RecordAPI } from "../../../../axios/api";
import moment from "moment";

import {
  FormCalendar,
  FormRadio,
  FormCheckbox,
  FormInputtext,
  FormDropdown,
} from "../../../../components/formElement";
import { formatResData, checkFormUpdate } from "../../../../service/common";
import {
  option_symptoms,
  option_hours,
  option_minutes,
} from "../../../../service/option";
import { rateHandler } from "../common";

import { classNames } from "primereact/utils";
import { Button } from "primereact/button";

export default function ModulePopRecordUncomfortableForm({
  prePopOption,
  closePrePop,
  openPrePop,
  setPreReload,
  memberid,
  moduleType,
  memberData,
}) {
  const dispatch = useDispatch();
  const [apiData, setApiData] = useState({});
  // 表單欄位預設值
  const defaultValues = {
    date: moment().format("YYYY/MM/DD"),
    type: null,
    status: null,
    time_hour: moment().format("HH"),
    time_minute: moment().format("mm"),
    u1: false,
    u2: false,
    u3: false,
    u4: false,
    u5: false,
    u6: false,
    u7: false,
    u8: false,
    u9: false,
    u10: false,
    u11: false,
    u12: false,
    u13: false,
    u14: false,
    u14_other: "",
    memberid: null,
  };
  const {
    handleSubmit,
    getValues,
    setValue,
    reset,
    trigger,
    watch,
    yup,
    setSchema,
    errors,
    setting,
  } = useHookForm({
    defaultValues,
  });
  // 監聽欄位
  const watchColumn = {
    status: watch("status"),
    u14: watch("u14"),
  };

  useEffect(() => {
    setSchema(
      yup
        .object({
          memberid: yup
            .number()
            .test("isValidPass", "必填", (value) => {
              return moduleType === "back" && !memberid ? value : true;
            })
            .nullable(),
          date: yup.string().required("必填"),
          type: yup.number().required("必填"),
          status: yup.number().required("必填"),
        })
        .required()
    );
  }, []);

  // 動態判斷欄位
  useEffect(() => {
    let submitData = getValues();

    if (submitData.status !== 1) {
      option_symptoms.forEach((item) => setValue(item.key, false));
      setValue("u14_other", "");
      trigger([...option_symptoms.map((item) => item.key), "u14_other"]);
    }
  }, [watchColumn.status]);
  useEffect(() => {
    let submitData = getValues();

    if (!submitData.u14) {
      setValue("u14_other", "");
      trigger(["u14_other"]);
    }
  }, [watchColumn.u14]);

  useAbortedEffect(
    (signal) => {
      if (!prePopOption.data) return;

      dispatch(setProgress(true));

      let params = { id: prePopOption.data.id };

      RecordAPI.getRecordUncomfortableSymptomsDetails({
        data: params,
        options: { signal },
      }).then((result) => {
        let { Response, data, message } = result;

        if (Response === 1) {
          option_symptoms.forEach((item) => {
            data[item.key] = data[item.key] === 1;
          });

          if (data.time) {
            data.time_hour = data.time.split(":")[0];
            data.time_minute = data.time.split(":")[1];
          }

          let temp = formatResData(defaultValues, data);
          setApiData(temp);
          reset(temp);
        } else {
          dispatch(
            setToast({
              severity: "error",
              summary: message,
              detail: "",
            })
          );
        }

        dispatch(setProgress(false));
      });
    },
    [prePopOption.data]
  );

  const onSubmit = (submitData) => {
    dispatch(setProgress(true));

    let isAdd = !prePopOption.data,
      jsonData = formatResData(defaultValues, submitData);
    if (jsonData.date)
      jsonData.date = moment(jsonData.date).format("YYYY-MM-DD");
    if (jsonData.time_hour && jsonData.time_minute)
      jsonData.time = `${jsonData.time_hour}:${jsonData.time_minute}`;
    if (jsonData.status !== 1) delete jsonData.time;

    if (!checkFormUpdate(jsonData, prePopOption.data ?? {})) {
      dispatch(
        setToast({
          severity: "warn",
          summary: "無資料變更",
          detail: "",
        })
      );
      dispatch(setProgress(false));
      closePrePop({ type: "form" });
      return;
    }

    option_symptoms.forEach(
      (item) => (jsonData[item.key] = jsonData[item.key] ? 1 : 0)
    );

    let promise,
      toast = "";
    if (isAdd) {
      // 新增
      promise = RecordAPI.setRecordUncomfortableSymptomsData({
        data: {
          ...jsonData,
          memberid: submitData.memberid ?? memberid,
        },
      });
      toast = "新增";
    } else {
      // 修改
      if (jsonData.date === prePopOption.data.date) delete jsonData.date;
      promise = RecordAPI.updateRecordUncomfortableSymptomsData({
        data: {
          ...jsonData,
          id: prePopOption.data.id,
        },
      });
      toast = "修改";
    }

    promise.then(async (result) => {
      let { Response, my_old_day_data, my_todays_data, message } = result;

      if (Response === 1) {
        await rateHandler({
          memberid: submitData.memberid ?? memberid,
          my_old_day_data,
          my_todays_data,
          old_date: isAdd ? null : prePopOption.data.date,
          now_date: submitData.date,
        });

        dispatch(
          setToast({
            severity: "success",
            summary: `${toast}成功`,
            detail: "",
          })
        );
        closePrePop({ type: "form" });
        setPreReload((state) => ({ ...state, list: true }));

        if (
          jsonData.u1 ||
          jsonData.u2 ||
          jsonData.u3 ||
          jsonData.u4 ||
          jsonData.u5 ||
          jsonData.u6 ||
          jsonData.u11
        )
          openPrePop({
            type: "confirm",
            data: {
              msg: `冠心病發作的常見症狀包括：\n胸悶/胸痛、呼吸喘/呼吸困難、冒冷汗、頭昏腦脹/頭暈/眩暈/暈厥感、疲倦/無力、噁心/嘔吐等，必要時請諮詢專業人員或盡速就醫`,
            },
          });
      } else {
        dispatch(
          setToast({
            severity: "error",
            summary: `${toast}失敗`,
            detail: message ?? "",
          })
        );
        dispatch(setProgress(false));
      }
    });
  };

  return (
    <>
      <div className="px-4">
        <form onSubmit={handleSubmit(onSubmit)} className="formgrid grid">
          {moduleType === "back" && !memberid && (
            <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12">
              <label
                htmlFor="memberid"
                className={classNames(
                  { "p-error": errors.memberid },
                  "col-12 sm:col-3 text-left sm:text-right mb-1 sm:mb-0"
                )}
              >
                <span className="text-red-400 mr-1">*</span>
                會員
              </label>
              <div className="col-12 sm:col-9">
                <FormDropdown
                  setting={setting}
                  data={{
                    name: "memberid",
                    options: memberData,
                    optionLabel: "name",
                    optionValue: "id",
                    filter: true,
                    filterBy: "name",
                    disabled: prePopOption.data,
                  }}
                />
              </div>
            </div>
          )}

          <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12">
            <label
              htmlFor="date"
              className={classNames(
                { "p-error": errors.date },
                "col-12 sm:col-3 text-left sm:text-right mb-1 sm:mb-0"
              )}
            >
              日期
            </label>
            <div className="col-12 sm:col-9">
              <FormCalendar
                setting={setting}
                data={{
                  name: "date",
                  // disabled: true,
                }}
              />
            </div>
          </div>

          <div className="flex flex-column align-items-start sm:flex-row field col-12">
            <label
              htmlFor="type"
              className={classNames(
                { "p-error": errors.type },
                "col-12 sm:col-3 text-left sm:text-right mb-1 sm:mb-0 sm:mt-2"
              )}
            >
              時段
            </label>
            <div className="flex flex-wrap col-12 sm:col-9">
              <FormRadio
                setting={setting}
                data={{
                  name: "type",
                  label: "早上",
                  value: 1,
                }}
              />
              <FormRadio
                setting={setting}
                data={{
                  name: "type",
                  label: "下午",
                  value: 2,
                }}
              />
              <FormRadio
                setting={setting}
                data={{
                  name: "type",
                  label: "晚上",
                  value: 3,
                }}
              />
            </div>
          </div>

          <div className="flex flex-column align-items-start sm:flex-row field col-12">
            <label
              htmlFor="status"
              className={classNames(
                { "p-error": errors.status },
                "col-12 sm:col-3 text-left sm:text-right mb-1 sm:mb-0 sm:mt-2"
              )}
            >
              是否有不適症狀
            </label>
            <div className="flex flex-wrap col-12 sm:col-9">
              <FormRadio
                setting={setting}
                data={{
                  name: "status",
                  label: "有",
                  value: 1,
                }}
              />
              <FormRadio
                setting={setting}
                data={{
                  name: "status",
                  label: "無",
                  value: 2,
                }}
              />
            </div>
          </div>

          {getValues("status") === 1 && (
            <>
              <div className="flex flex-column align-items-start sm:flex-row field col-12">
                <label
                  className={classNames(
                    "col-12 sm:col-3 text-left sm:text-right mb-1 sm:mb-0 sm:mt-2"
                  )}
                >
                  不適症狀
                </label>
                <div className="col-12 sm:col-9">
                  {option_symptoms.map((symptom) => (
                    <FormCheckbox
                      setting={setting}
                      data={{
                        name: symptom.key,
                        label: symptom.label,
                        value: true,
                        type: "checked",
                      }}
                    />
                  ))}
                </div>
              </div>

              {getValues("u14") && (
                <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12">
                  <label
                    htmlFor="u14_other"
                    className={classNames(
                      { "p-error": errors.u14_other },
                      "col-12 sm:col-3 text-left sm:text-right mb-1 sm:mb-0"
                    )}
                  >
                    其他症狀
                  </label>
                  <div className="col-12 sm:col-9">
                    <FormInputtext
                      setting={setting}
                      data={{
                        name: "u14_other",
                      }}
                    />
                  </div>
                </div>
              )}

              <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12">
                <label
                  htmlFor="time"
                  className={classNames(
                    { "p-error": errors.time },
                    "col-12 sm:col-3 text-left sm:text-right mb-1 sm:mb-0"
                  )}
                >
                  症狀發生時間
                </label>
                <div className="flex align-items-center col-12 sm:col-9">
                  {/* <FormCalendar
                    setting={setting}
                    data={{
                      name: "time",
                      timeOnly: true,
                      hourFormat: "12",
                      showTime: true,
                      showSeconds: false,
                      showButtonBar: false,
                      // disabled: true,
                    }}
                  /> */}
                  <FormDropdown
                    className="w-5rem"
                    setting={setting}
                    data={{
                      name: "time_hour",
                      options: option_hours,
                      showClear: false,
                    }}
                  />
                  <span className="mx-2">時</span>
                  <FormDropdown
                    className="w-5rem"
                    setting={setting}
                    data={{
                      name: "time_minute",
                      options: option_minutes,
                      showClear: false,
                    }}
                  />
                  <span className="ml-2">分</span>
                </div>
              </div>
            </>
          )}

          <div className="col-12 text-right">
            <Button
              type="button"
              label="取消"
              className="p-button-secondary p-button-outlined ml-auto px-3"
              onClick={() => closePrePop({ type: "form" })}
            />
            <Button type="submit" label="儲存" className="ml-2 mr-2 px-3" />
          </div>
        </form>
      </div>
    </>
  );
}
